import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7ec3881e")

_pushScopeId("data-v-7ec3881e")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Home")
const _hoisted_2 = {
  key: 0,
  class: "loading_spinner"
}
const _hoisted_3 = {
  key: 1,
  class: "page_content"
}
const _hoisted_4 = { class: "main_events_container" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "section_title" }, " Prossimi eventi ", -1)
const _hoisted_6 = { class: "content" }
const _hoisted_7 = {
  key: 0,
  class: "no_event_container"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "no_event" }, " Nessun evento programmato ", -1)
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "title" }
const _hoisted_11 = { class: "main_sondaggi_container" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "section_title" }, " Sondaggi in corso ", -1)
const _hoisted_13 = { class: "content" }
const _hoisted_14 = {
  key: 0,
  class: "no_sondaggi_container"
}
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "no_sondaggi" }, " Nessun sondaggio da compilare ", -1)
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "title" }
const _hoisted_18 = { class: "actions" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ion_title = _resolveComponent("ion-title")
  const _component_ion_icon = _resolveComponent("ion-icon")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_buttons = _resolveComponent("ion-buttons")
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")
  const _component_ion_header = _resolveComponent("ion-header")
  const _component_ion_spinner = _resolveComponent("ion-spinner")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_ion_page = _resolveComponent("ion-page")

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_header, { translucent: true }, {
        default: _withId(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withId(() => [
              _createVNode(_component_ion_title, { color: "white" }, {
                default: _withId(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, {
                onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.openMenu())),
                slot: "start"
              }, {
                default: _withId(() => [
                  _createVNode(_component_ion_button, null, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, {
                        icon: $setup.menu,
                        slot: "start"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, { slot: "end" }, {
                default: _withId(() => [
                  _createVNode(_component_ion_button, {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.refreshData()))
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, {
                        slot: "start",
                        icon: $setup.refresh,
                        color: "white"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withId(() => [
          ($setup.loading)
            ? (_openBlock(), _createBlock("div", _hoisted_2, [
                _createVNode(_component_ion_spinner, {
                  name: "crescent",
                  color: "dark"
                })
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_3, [
                _createVNode("div", _hoisted_4, [
                  _hoisted_5,
                  _createVNode("div", _hoisted_6, [
                    ($setup.events.length == 0)
                      ? (_openBlock(), _createBlock("div", _hoisted_7, [
                          _hoisted_8
                        ]))
                      : (_openBlock(), _createBlock("div", _hoisted_9, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.events, (event) => {
                            return (_openBlock(), _createBlock("div", {
                              key: event.events_calendar_id,
                              onClick: ($event: any) => ($setup.openEventDetail(event)),
                              class: "event"
                            }, [
                              _createVNode(_component_ion_icon, {
                                slot: "start",
                                icon: $setup.calendar,
                                class: "calendar_icon"
                              }, null, 8, ["icon"]),
                              _createVNode("div", _hoisted_10, _toDisplayString(event.events_calendar_title), 1)
                            ], 8, ["onClick"]))
                          }), 128))
                        ]))
                  ])
                ]),
                _createVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createVNode("div", _hoisted_13, [
                    ($setup.sondaggi.length == 0)
                      ? (_openBlock(), _createBlock("div", _hoisted_14, [
                          _hoisted_15
                        ]))
                      : (_openBlock(), _createBlock("div", _hoisted_16, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.sondaggi, (sondaggio) => {
                            return (_openBlock(), _createBlock("div", {
                              key: sondaggio.sondaggi_id,
                              onClick: ($event: any) => ($setup.openSodaggioDetail(sondaggio)),
                              class: "sondaggio"
                            }, [
                              _createVNode("div", _hoisted_17, [
                                _createVNode("span", null, _toDisplayString($setup.setShortSondaggioTitle(sondaggio.sondaggi_titolo)), 1)
                              ]),
                              _createVNode("div", _hoisted_18, [
                                (sondaggio.sondaggi_id % 2 === 0)
                                  ? (_openBlock(), _createBlock("div", _hoisted_19, [
                                      _createVNode(_component_ion_icon, {
                                        slot: "start",
                                        icon: $setup.checkmarkCircle,
                                        class: "sondaggio_action complete"
                                      }, null, 8, ["icon"])
                                    ]))
                                  : (_openBlock(), _createBlock("div", _hoisted_20, [
                                      _createVNode(_component_ion_icon, {
                                        slot: "start",
                                        icon: $setup.arrowForward,
                                        color: "white",
                                        class: "sondaggio_action"
                                      }, null, 8, ["icon"])
                                    ]))
                              ])
                            ], 8, ["onClick"]))
                          }), 128))
                        ]))
                  ])
                ])
              ]))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})